<template>
  <div class=" is-fullwidth">
    <table class="table is-hoverable is-fullwidth" id="orderstable">
    	<thead>
    		<tr>
        <th width="10">&nbsp;</th>
        <th>PO Number</th>
        <th>Sales Rep</th>
   	 		<th>Customer</th>
          <th>Description</th>
          <th>Colour</th>
          <th>Quantity</th>
          <th>Order Date</th>
          <th>Order Required</th>
   	 	    </tr>
    	</thead>
    	<tbody>
		    <tr v-if="loading===true">
          <td colspan="9"><strong>Loading orders ...</strong></td>
          </tr>
        <tr v-for="order in orders" v-bind:key="order.orderID">
          <td><input type="checkbox" class="form-control" v-model="order.checked" /></td>
          <td >{{order.ponumber}}</td>
          <td>{{order.rep}}</td>
          <td>{{order.clientname}}</td>
          <td>{{order.garmentname}}</td>
           <td>{{order.design_colourway}}</td>
          
          <td></td>
          
          <td>{{order.orderDate}}</td>
          <td>{{order.deliveryDate}}</td>
          
             
              
			</tr>
    	</tbody>
    </table>

     
    
    <button @click="exportXLS()" class="button is-info" >Export to Excel</button>
    
    <OrderModal :showModal="showModal" @closeModal="showModal=false" :orderID="selectedOrderID"/>


    
    
    
  </div>
</template>

<script>
import XLSX from 'xlsx';

import OrderModal from '@/components/OrderModal';

import OrderService from '@/services/OrderService.js';

export default {
  name:'NewStockOrders',
  components: {
   	OrderModal
  },
  data() {
    return {
       errors: [],
      orders: [],
      
      showModal: false,
      selectedOrderID: 0,
     accessToken: '',
     loading:true
    }
  },
  created() {
      this.getAccessToken()
        .then(() => { 
            this.getOrders()
        });
      
    },
  methods: {
    async getAccessToken() {
        this.accessToken = await this.$auth.getTokenSilently()
    },
   
    async getOrders() {
      this.loading=true;
     OrderService.getStockOrders(this.accessToken)
      .then(
        (orders => {
          this.$set(this, "orders", orders);
          this.loading=false;
        }).bind(this)
      );
    },
    
    exportXLS() {
		 //alert("hi")
		 //var wb = XLSX.utils.table_to_book(document.getElementById('hiddentable'), {sheet:"Sheet JS"});
		 //XLSX.writeFile(wb, 'After Macro.xlsx')
     /* Generate Workbook */
      if(this.checkedOrders.length > 0)
      {
      var wb = XLSX.utils.book_new();
      var data = [['PRIORITY','ORDER NO','SALES REP','CUSTOMER', 'DESCRIPTION', 'COLOUR', 'QTY', 'QTY DIS', 'BAL', 'DATE ORDERED']]

      for (var i = 0, length = this.checkedOrders.length; i < length; i++) {
        var row = i+2;
        var order =this.checkedOrders[i];
        data.push(['', order.ponumber, order.rep, order.clientname, order.garmentname, order.design_colourway, 100, 0, {f:'G'+row+'-H'+row}]);
      }

      var ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "SheetJS");

      /* Trigger Download with `writeFile` */
      XLSX.writeFile(wb, "SheetJS.xlsx", {compression:true});
      }
      else{
        alert("You have not selected any orders to export")
      }
	 },
   
  },
  computed : {
     checkedOrders: function () {
        let checkedOrders = []
        checkedOrders = this.orders.filter(row => row.checked === true)
       return checkedOrders
     } 

  },

 
  mounted() {
    
  },
  watch: {
    
  }
}



</script>

<style>
	td span {cursor:pointer;text-decoration:underline #ccc}
  table.is-hoverable tbody tr:hover {background-color:#ededed !important}
</style>
